const auth = {
  namespaced: true,
  state: {
    employeeTypes: {
      CBM: 'SCG CBM',
      CHEM: 'SCG Chemicals',
      PACK: 'SCG Packaging',
      CAFI: 'SCG CA&FI',
      OTHER: 'พนักงานในเครือ',
      NONSCG: 'ไม่ใช่พนักงาน'
    },
    questions: {
      hQ1: 'ช่วง 14 วันที่ผ่านมา ได้เดินทางไปต่างจังหวัด',
      hQ1a: 'ระบุจังหวัด',
      hQ2: 'ช่วง 14 วันที่ผ่านมาได้เข้ารับการรักษา หรือเยี่ยมผู้ป่วยในโรงพยาบาลของพื้นที่ที่มีการระบาด',
      hQ3: 'ช่วง 14 วันที่ผ่านมา ได้ดูแลหรือสัมผัสใกล้ชิด กับผู้ป่วยอาการคล้ายไข้หวัดใหญ่ หรือปอดอักเสบ',
      hQ4: 'ช่วง 14 วันที่ผ่านมา มีประวัติสัมผัสกับผู้ป่วยติดเชื้อไวรัสโควิด-2019',
      hQ5: 'ช่วง 14 วันที่ผ่านมา ประกอบอาชีพที่สัมผัสใกล้ชิดกับนักท่องเที่ยวต่างชาติ',
      hQ6: 'ช่วง 14 วันที่ผ่านมา มีประวัติเดินทางไปในสถานที่ ที่มีคนหนาแน่น เช่น ผับ สนามมวย เป็นต้น',
      hQ6a: 'ระบุสถานที่',
      hQ7: 'ปัจจุบันท่านมีอาการผิดปกติ เช่น ไอ ปวดศีรษะ หรือไม่',
      
      sQ1: 'มีอาการไข้',
      sQ1a: 'ระบุอุณหภูมิ',
      sQ2: 'มีอาการไอ',
      sQ3: 'เจ็บคอ',
      sQ4: 'มีอาการปวดกล้ามเนื้อ',
      sQ5: 'มีน้ำมูก',
      sQ6: 'มีเสมหะ',
      sQ7: 'หายใจลำบาก',
      sQ8: 'ปวดศีรษะ',
      sQ9: 'ถ่ายเหลว',
      sQ10: 'สูญเสียการได้กลิ่น',
      sQ11: 'ตาแดง',
      sQ12: 'มีผื่นขึ้นตามตัว',
      sQ13: 'สูญเสียการรับรส',
      sQ14: 'อื่น ๆ',
      sQ14a: 'ระบุ',
      
      vQ1: 'ท่านเคยตรวจหาภูมิคุ้มกัน (แอนติบอดี) ต่อเชื้อไวรัสโควิด-19 มาก่อนหรือไม่',
      vQ1a: 'วันที่ตรวจครั้งล่าสุด',
      vQ6: 'ท่านเคยได้รับการตรวจวินิจฉัยว่าติดเชื้อไวรัสโคโรนา 2019 มาก่อนหรือไม่',
      vQ6Year: 'วันที่ตรวจวินิจฉัย',
      vQ2: 'ท่านเคยรับการฉีดวัคซีนโควิด-19 มาก่อนหรือไม่',
      vQ4: 'จำนวนเข็ม',
      vQ5: 'วันที่ฉีดเข็มแรก',
      vQ3: 'ชนิดวัคซีนเข็มที่หนึ่งที่ได้รับ',
      vQ3a: 'ระบุ',
      vQ9: 'วันที่ฉีดเข็มสอง',
      vQ7: 'ชนิดวัคซีนเข็มที่สองที่ได้รับ',
      vQ8: 'ระบุ',
      vQ2a: 'วันที่ได้รับวัคซีนครั้งล่าสุด',
      vQ10: 'ชนิดวัคซีนเข็มที่สามที่ได้รับ',
      vQ11: 'ระบุ',
      vQ12: 'ท่านอยู่ระหว่างได้รับยากดภูมิคุ้มกันหรือไม่',
      vQ13: 'ระบุชื่อยา',
      vQ14: 'ท่านมีโรคประจำตัวหรือไม่',
      vQ15: 'ระบุโรคประจำตัว',
    },
    bloodGroups: [
      {
        key: '',
        value: 'Not Specific'
      },
      {
        key: 'A',
        value: 'A'
      },
      {
        key: 'B',
        value: 'B'
      },
      {
        key: 'AB',
        value: 'AB'
      },
      {
        key: 'O',
        value: 'O'
      }
    ],
    genders: [
      {
        key: 'M',
        value: 'M'
      },
      {
        key: 'F',
        value: 'F'
      }
    ],
    yn: [
      {
        key: 'Y',
        value: 'Yes'
      },
      {
        key: 'N',
        value: 'No'
      }
    ],
  },
  getters: {
    employeeTypes: (state) => {
      return state.employeeTypes;
    },
    questions: (state) => {
      return state.questions;
    },
    bloodGroups: (state) => {
      return state.bloodGroups;
    },
    genders: (state) => {
      return state.genders;
    },
    yn: (state) => {
      return state.yn;
    },
  },
  mutations: {},
  actions: {}
}

export default auth;